import React from 'react';
import classNames from 'classnames';
import { makeStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Paper from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Paper';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { getBorderRadius } from 'Components/utils';

const useStyles = makeStyles((theme) => ({
  root: {
    display: 'flex',
    alignItems: 'center',
    padding: theme.spacing(2),
    ...getBorderRadius(theme.radius.none, { top: true }),
  },
}));

const CommentsHeader = () => {
  const classes = useStyles();

  return (
    <Paper
      className={classNames(classes.root)}
    >
      <Typography
        className={classes.title}
        variant="h2"
        color="black"
        weight={'bold'}
        align={'left'}
      >
        {'Comments'}
      </Typography>
    </Paper>
  );
};

export default CommentsHeader;
